const myColors = [
  'black',
  'white',
  'purple',
  '#452632',
  '#856325',
  '#963254',
  '#254563',
];

export const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: ['', 'serif', 'monospace'] }],
    [
      {
        size: ['', 'small', 'large', 'huge'],
      },
    ],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { align: '' },
      { align: 'right' },
      { align: 'center' },
      { align: 'justify' },
    ],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    [{ background: myColors }, { color: myColors }],
  ],
};

export const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'link',
  'color',
  'background',
  'align',
  'font',
  'size',
];
